import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const DataGridLoadingOverlay: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      gap: 1.5,
      color: "text.secondary",
    }}
  >
    <CircularProgress size={28} />
    <Typography variant="body2">Loading...</Typography>
  </Box>
);

export default DataGridLoadingOverlay;
